<script setup lang="ts" generic="T extends string">
const props = defineProps<{
  product: SingleProduct;
  defaultOpen: boolean;
  gradeOptions: Options<T, { grades?: GradeCode[] }>;
}>();

const route = useRoute();

const variants = computed<SingleProduct["variants"]>(() => {
  const filters = route.query;

  return props.product.variants
    .filter(byFormats(filters))
    .filter(byGrades(filters, props.gradeOptions))
    .filter(byLevels(filters))
    .sort(productVariants);
});
</script>

<template>
  <UContainer
    v-if="variants.length > 0"
    as="section"
    class="bg-white pb-20"
  >
    <UiProductsExpandable
      v-for="variant in variants"
      :key="variant.isbn"
      :variant="variant"
      :default-open="defaultOpen"
    />
  </UContainer>
</template>
